export enum FeatureFlag {
  RELEASE_NOVO_LAYOUT_NAOENCOTRADO = 'release_novo_layout_naoencontrado',
}
